$(document).ready(function () {
    if ($(".brochureLibraryPage").length) {
        var showBrochures = function showBrochures(data) {
            var output = "";

            for (var i in data) {
                output += "<div class=\"col-md-6 col-lg-3 brochure-item\">\n                        <a class=\"d-block max-width-200\" target=\"_blank\" href=\"" + data[i].FileUrl + "\">\n                            <div class=\"brochure-image-container\"><div class=\"brochure-image\" style=\"background-image: url('" + data[i].ThumbnailUrl + "')\"></div> </div>\n                            <div class=\"text-container brochureName link\">" + data[i].Name + "</div>\n                        </a>\n                    </div>";
            }

            $("#brochureOutput").html(output);
        };

        var initShowAllBrochures = function initShowAllBrochures() {
            sendAjax();
        };

        var sendAjax = function sendAjax() {
            return $.ajax({
                url: location.href + "ajaxRequest",
                data: {
                    "catID": $(".categorySelector").val(),
                    "value": $(".searchBox").val()
                },
                beforeSend: function beforeSend(xhr) {
                    xhr.overrideMimeType("text/plain; charset=x-user-defined");
                }
            }).then(function (result) {
                if (result) {
                    result = JSON.parse(result);
                    showBrochures(result);
                } else {
                    console.log("error");
                }
            });
        };

        $(".categorySelector").change(function () {
            sendAjax();
        });
        $(".searchBox").change(function () {
            sendAjax();
        });
        $(".searchButton").click(function (e) {
            e.preventDefault();
            sendAjax();
        });
        initShowAllBrochures();
    }
});